module.exports = __webpack_public_path__ + "img/apr-2.dd63a57d.jpg";